import { render, staticRenderFns } from "./usedomaincred-modal.vue?vue&type=template&id=3b79d464&scoped=true&"
import script from "./usedomaincred-modal.vue?vue&type=script&lang=tsx&"
export * from "./usedomaincred-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./usedomaincred-modal.vue?vue&type=style&index=0&id=3b79d464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b79d464",
  null
  
)

export default component.exports